import React, { forwardRef, useContext, useState } from 'react';
import cn from 'clsx';
import { string, number, func, any } from 'prop-types';
import FormContext from '../../context/FormContext.js';
import FormGroupContext from '../../context/FormGroupContext.js';

/**
 * FormRange component.
 */
const FormRange = /*#__PURE__*/forwardRef(({
  name,
  topLabel,
  rightLabel,
  leftLabel,
  min,
  max,
  className,
  onChange,
  step,
  defaultValue
}, ref) => {
  const {
    inputId,
    feedbackId
  } = useContext(FormGroupContext);
  const {
    inverted,
    defaultValues,
    validateInput
  } = useContext(FormContext);
  const [value, setValue] = useState(defaultValue || (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues[name]) || 0);
  const handleChange = evt => {
    const rangeValue = evt.target.value;
    setValue(rangeValue);
    if (onChange) {
      onChange(rangeValue);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cn("form-range text-center", className, !topLabel && 'd-flex', inverted && 'form-range--inverted')
  }, topLabel && /*#__PURE__*/React.createElement("div", {
    className: "text-center pb-xxs"
  }, topLabel), leftLabel && /*#__PURE__*/React.createElement("span", {
    className: 'form-range__label'
  }, leftLabel), /*#__PURE__*/React.createElement("input", {
    autoComplete: "off",
    id: inputId,
    type: "range",
    className: "form-range__input",
    min: min,
    max: max,
    onChange: validateInput ? evt => validateInput(evt, handleChange) : handleChange,
    ref: ref,
    step: step,
    name: name,
    value: value || min,
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-describedby": feedbackId
  }), rightLabel && /*#__PURE__*/React.createElement("span", {
    className: 'form-range__label'
  }, rightLabel));
});
FormRange.displayName = 'FormRange';
FormRange.defaultProps = {
  defaultValue: null,
  topLabel: null,
  leftLabel: null,
  rightLabel: null,
  className: null,
  min: 1,
  max: 10,
  onChange: null,
  step: 1
};
FormRange.propTypes = process.env.NODE_ENV !== "production" ? {
  /** defaultValue of the input */
  defaultValue: any,
  /** Name to identify the input */
  name: string.isRequired,
  /** Additional class names to add to the component root. */
  className: string,
  /** Left Label of the range */
  topLabel: string,
  /** Left Label of the range */
  leftLabel: string,
  /** Right Label of the range */
  rightLabel: string,
  /** Minimum value of the range */
  min: number,
  /** Maximum value of the range */
  max: number,
  /** Additional onChange */
  onChange: func,
  /** Step attribue this sets the granularity that the value must adhere to */
  step: number
} : {};
export default FormRange;